import { IonIcon, IonModal, IonText } from "@ionic/react"
import { useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import './stripeModalPayment.css'
import { closeOutline } from "ionicons/icons";
import { useRecoilState, useRecoilValue } from "recoil";
import { stripeErrorAPI } from "recoil/StripeErrorAtom";
import { StripePaymentError } from "pages/sesiones/components/session-checkout/stripePaymentError";
import { StripePaySubscriptionForm } from "./StripePaySubscriptionForm";
import { planSelectedState } from "recoil/planAtom";
import { SubscriptionSuccesful } from "pages/subscription/SubscriptionSuccesful";
import { StripePayChangePlanForm } from "./StripePayChangePlanForm";
import { formatCurrency } from "helper/handleAmountParse";

interface IStripeModalPayent{ 
    isOpen:boolean,
    handleOpen: (type:string)=> void,
    handleCloseModal: ()=> void,
    nextInvoice: any
}

export const StripeModalChangePlan: React.FC <IStripeModalPayent> = ({ isOpen, handleOpen, handleCloseModal, nextInvoice })=> { 

    const modalRef = useRef(null)
    const stripePromise = loadStripe(String(process.env.REACT_APP_STRIPE_KEY), { locale:'es-419'});
    const [stripeError, setStripeError] = useRecoilState(stripeErrorAPI)
    const planSelected = useRecoilValue(planSelectedState)

    const priceDecimal = formatCurrency(Number(nextInvoice.total/100)) 

    const handleDisMiss = ()=>{ 
        handleCloseModal()
        setStripeError({
            code:null,
            declineCode:null
        })
    }
    return (
        <IonModal ref={modalRef} id={ stripeError.code === "succeeded" ? "stripe-form-modal-subs-success" : "stripe-form-modal-subs" } isOpen={isOpen} onDidDismiss={handleDisMiss}>
            <Elements stripe={stripePromise}>
                <div className="modal-content-stripe">
                    <div className="modal-header-close">
                        <IonIcon 
                            onClick={handleDisMiss} 
                            color="dark" 
                            style={{ width:30, height:30 }} 
                            slot="icon-only" 
                            icon={closeOutline}></IonIcon>
                    </div>
                    {
                        !stripeError.code ?
                        <>
                            <div style={{ width:'100%', marginBottom:10 }}>
                                <IonText className="ion-text-header"> Plan de Suscripción Anual { 'Premium' } </IonText>
                            </div>
                            <div className="header-stripe-modal">
                                <IonText className="ion-text-header"> Total a pagar: </IonText>
                                <IonText className="ion-text-header"> USD ${priceDecimal} </IonText>
                            </div>
                            <StripePayChangePlanForm nextInvoice={nextInvoice} />
                        </>
                        :
                            stripeError.code === "succeeded" ?
                            <SubscriptionSuccesful />
                        :
                            <StripePaymentError stripeError={stripeError} />
                    }
                    
                </div>
            </Elements>
        </IonModal>
    )
}